import { ref } from 'vue'

const notifications = ref([])
let notificationSeq = 0
const notificationTimers = new Map()

export function pushNotification({ type = 'info', title = '', message = '', duration = 3200 } = {}) {
  const id = `n-${Date.now()}-${notificationSeq++}`
  notifications.value = [
    ...notifications.value,
    {
      id,
      type: String(type || 'info'),
      title: String(title || ''),
      message: String(message || ''),
    },
  ].slice(-5)
  const timeout = window.setTimeout(() => dismissNotification(id), Math.max(1200, Number(duration || 0)))
  notificationTimers.set(id, timeout)
  return id
}

export function dismissNotification(id) {
  const key = String(id || '')
  const timeout = notificationTimers.get(key)
  if (timeout) {
    clearTimeout(timeout)
    notificationTimers.delete(key)
  }
  notifications.value = notifications.value.filter((item) => item.id !== key)
}

export function clearNotifications() {
  for (const timeout of notificationTimers.values()) clearTimeout(timeout)
  notificationTimers.clear()
  notifications.value = []
}

export function notificationClass(type) {
  const value = String(type || 'info').trim().toLowerCase()
  if (value === 'success') return 'border-emerald-700/60 bg-emerald-950/90 text-emerald-100'
  if (value === 'error') return 'border-rose-700/60 bg-rose-950/90 text-rose-100'
  if (value === 'warning') return 'border-amber-700/60 bg-amber-950/90 text-amber-100'
  return 'border-sky-700/60 bg-sky-950/90 text-sky-100'
}

export function pushSuccess(title, message = '', duration = 3200) {
  return pushNotification({ type: 'success', title, message, duration })
}

export function pushError(title, message = '', duration = 4500) {
  return pushNotification({ type: 'error', title, message, duration })
}

export function pushWarning(title, message = '', duration = 3600) {
  return pushNotification({ type: 'warning', title, message, duration })
}

export function pushInfo(title, message = '', duration = 3200) {
  return pushNotification({ type: 'info', title, message, duration })
}

export function useNotifications() {
  return {
    notifications,
    pushNotification,
    dismissNotification,
    clearNotifications,
    notificationClass,
    pushSuccess,
    pushError,
    pushWarning,
    pushInfo,
  }
}
